import { ReactComponent as CurveFooter } from "../../assets/curve-footer.svg";
import React from "react";
import { t } from "../../core/localization/source";

export default function Footer() {
  return (
    <section className="row m-0 bg-secondary-light text-light footer pt-5 mt-4">
      <CurveFooter
        preserveAspectRatio="none"
        className="footer-curve fill-secondary-light"
      />
      <div className="container mt-3 mb-5 pb-4">
        <div className="row col-12">
          <div className="col-sm-6 col-md-4 mb-4 mb-md-0">
            <h4>{t("navigation.contact")}</h4>
            <ul>
              <li>
                <a
                  href="https://goo.gl/maps/FW6JFCAf5tPSc5w86"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-unstyled"
                >
                  {t("contact.street")}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+32487699745`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-unstyled"
                >
                  +32 487 69 97 45
                </a>
              </li>
              <li>
                <a
                  href={`mailto:gsuarez23@gmail.com`}
                  className="link-unstyled"
                >
                  gsuarez23@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="col-sm-6 col-md-3 mb-4 mb-md-0">
            <h4>Belgische acupunctuur federatie</h4>
            <ul>
              <li>1.24.002.1</li>
            </ul>
            <h4 className="mt-4">{t("footer.riziv.title")}</h4>
            <ul>
              <li>5 485 88 44 527</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
